export default __webpack_public_path__ + "static/Plots0002-5fccc120dbc940dcbe15c15dd3b68b46.jpg";